var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
          [
            _c(
              "c-table",
              {
                ref: "table",
                attrs: {
                  title: "작업환경측정결과(소음제외)",
                  columns: _vm.grid.columns,
                  gridHeight: _vm.gridHeight,
                  data: _vm.measData.notNoiseList,
                  filtering: true,
                  columnSetting: false,
                  merge: _vm.grid.merge,
                  usePaging: false,
                  editable: !_vm.disabled,
                  noDataLabel: "작업환경측정결과를 추가하세요.",
                  selection: "multiple",
                  rowKey: "workMeasurementResultId",
                },
                on: { linkClick: _vm.linkClick },
                scopedSlots: _vm._u([
                  {
                    key: "customArea",
                    fn: function ({ props, col }) {
                      return [
                        col.name === "customCol"
                          ? [
                              _c(_vm.imprComponent, {
                                tag: "component",
                                attrs: {
                                  col: col,
                                  props: props,
                                  inputEditable: !_vm.disabled,
                                  isImmShow: true,
                                  requestContentsCols: _vm.requestContentsCols,
                                  tableKey: "workMeasurementResultId",
                                  ibmTaskTypeCd: "ITT0000175",
                                  ibmTaskUnderTypeCd: "ITTU000200",
                                },
                                on: { imprChange: _vm.imprChange },
                              }),
                            ]
                          : col.name === "heaCheckup"
                          ? [
                              Boolean(_vm.data.heaCheckupPlanId)
                                ? _c(
                                    "q-btn",
                                    {
                                      staticClass: "tableinnerBtn",
                                      attrs: {
                                        flat: "",
                                        round: "",
                                        align: col.align,
                                        color: "blue-6",
                                        icon: "search",
                                      },
                                    },
                                    [
                                      _c(
                                        "q-popup-proxy",
                                        {
                                          on: {
                                            "before-show": (e) =>
                                              _vm.getCheckupResult(props),
                                          },
                                        },
                                        [
                                          _c(
                                            "q-banner",
                                            [
                                              _c("c-table", {
                                                ref: "checkuptable",
                                                attrs: {
                                                  title: "검진결과 목록",
                                                  columns:
                                                    _vm.gridCheckup.columns,
                                                  gridHeight:
                                                    _vm.gridCheckup.height,
                                                  merge: _vm.gridCheckup.merge,
                                                  data: _vm.gridCheckup.data,
                                                  filtering: false,
                                                  columnSetting: false,
                                                  usePaging: false,
                                                  isExcelDown: false,
                                                  isFullScreen: false,
                                                  expandAll: true,
                                                },
                                                on: {
                                                  linkClick:
                                                    _vm.checkupResultPopOpen,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          : col.name === "measValue"
                          ? [
                              _c("span", [
                                _vm._v(" " + _vm._s(props.row.measValue) + " "),
                              ]),
                              props.row.measRecent == null ||
                              props.row.measRecent == 0
                                ? _c("span", { staticClass: "text-black-7" }, [
                                    _c("br"),
                                    _vm._v(" - "),
                                  ])
                                : Math.sign(Number(props.row.measRecent)) === 1
                                ? _c("span", { staticClass: "text-red-7" }, [
                                    _c("br"),
                                    _vm._v(
                                      " " +
                                        _vm._s(props.row.measRecent) +
                                        " (증가) "
                                    ),
                                  ])
                                : Math.sign(Number(props.row.measRecent)) === -1
                                ? _c("span", { staticClass: "text-blue-7" }, [
                                    _c("br"),
                                    _vm._v(
                                      " " +
                                        _vm._s(props.row.measRecent) +
                                        " (감소) "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              },
              [
                _c(
                  "template",
                  { slot: "table-button" },
                  [
                    _c(
                      "q-btn-group",
                      { attrs: { outline: "" } },
                      [
                        _vm.isOld && !_vm.disabled && _vm.editable
                          ? _c("c-btn", {
                              attrs: {
                                label: "엑셀 업로드",
                                icon: "assignment",
                              },
                              on: { btnClicked: _vm.openExcelUploader },
                            })
                          : _vm._e(),
                        _vm.isOld && !_vm.disabled && _vm.editable
                          ? _c("c-btn", {
                              attrs: {
                                showLoading: false,
                                label: "LBLADD",
                                icon: "add",
                              },
                              on: { btnClicked: _vm.add },
                            })
                          : _vm._e(),
                        _vm.isOld && !_vm.disabled && _vm.editable
                          ? _c("c-btn", {
                              attrs: {
                                showLoading: false,
                                label: "LBLREMOVE",
                                icon: "remove",
                              },
                              on: { btnClicked: _vm.remove },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ],
          1
        ),
      ]),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }